// Module
var code = `<div class="HOA-page-scrollable">
    <div class="HOA-page-expandable-col">
        <div class="HOA-page-expandable-row HOA-page-expandable-row-fill">
            <div
                    [ngClass]="{ 'HOA-page-padding': usePagePadding }"
                    class="u-display-table-cell u-width-100p" comment="must use table-cell inside table-row to use height: 100%">
                <ng-content></ng-content>
                <!-- Page Content -->
            </div>
        </div>
        <app-web-footer
                *ngIf="showWebFooter"
                class="HOA-page-expandable-row"
                [pmcId]="pmcId"
                [hoaId]="hoaId"
                [propertyId]="propertyId">
        </app-web-footer>
    </div>
</div>`;
// Exports
module.exports = code;